export default "__VITE_PUBLIC_ASSET__00c15dcb__"